import { render, staticRenderFns } from "./shop-channel-manual-shopee.vue?vue&type=template&id=3d595c45&scoped=true"
import script from "./shop-channel-manual-shopee.vue?vue&type=script&lang=js"
export * from "./shop-channel-manual-shopee.vue?vue&type=script&lang=js"
import style0 from "./shop-channel-manual-shopee.vue?vue&type=style&index=0&id=3d595c45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d595c45",
  null
  
)

export default component.exports